export const buildInfo: { gitHash: string; dateTime: number | 'local' } = { gitHash: '2614577', dateTime: 1770158133513 };